import type { IconData } from '@stacksjs/iconify-core'

export const atom: IconData = {
  "body": "<g fill=\"none\" stroke-width=\"3\"><path stroke=\"#2859c5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M42.258 5.742c6.152 6.151 1.39 17.738-8.694 27.822S11.893 48.41 5.742 42.258c-6.152-6.151-1.39-17.738 8.694-27.822S36.107-.41 42.258 5.742\"/><path stroke=\"#2859c5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5.742 5.742c-6.152 6.151-1.39 17.738 8.694 27.822s21.671 14.846 27.822 8.694c6.152-6.151 1.39-17.738-8.694-27.822S11.893-.41 5.742 5.742\"/><path fill=\"#8fbffa\" d=\"M18 24a6 6 0 1 0 12 0a6 6 0 1 0-12 0\"/><path stroke=\"#2859c5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M18 24a6 6 0 1 0 12 0a6 6 0 1 0-12 0\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default atom
